import { Dialog, DialogContent } from '@mui/material';

import Button from '@mui/material/Button';
import CloseIcon from '@mui/icons-material/Close';
import Grid from '@mui/material/Unstable_Grid2';
import IconButton from '@mui/material/IconButton';
import { NewAttemptLabel } from './LessonFlowDialog';
import React from 'react';
import Typography from '@mui/material/Typography';

interface ILessonFlowWarningDialog {
  label: NewAttemptLabel;
  handleConfirmRestart: () => void;
  handleClose: () => void;
}

export const LessonFlowWarningDialog = (props: ILessonFlowWarningDialog) => {
  const { label, handleClose, handleConfirmRestart } = props;

  return (
    <Dialog open>
      <DialogContent>
        <Grid
          container
          spacing={2}
          justifyContent={'center'}
          direction={'column'}
        >
          <IconButton
            color="primary"
            size="small"
            onClick={handleClose}
            sx={{ alignSelf: 'end' }}
          >
            <CloseIcon />
          </IconButton>
          <Grid sx={{ alignSelf: 'center' }}>
            <Typography variant="h6" textAlign={'center'}>
              Are you sure?
            </Typography>
            <Typography variant="body2" textAlign={'center'}>
              {label}ing this lesson will erase your progress, which cannot then
              be recovered.
            </Typography>
          </Grid>

          <Grid>
            <Grid container spacing={2} justifyContent={'center'}>
              <Grid>
                <Button
                  color="primary"
                  variant="outlined"
                  size="medium"
                  onClick={handleClose}
                >
                  No thanks, cancel
                </Button>
              </Grid>

              <Grid>
                <Button
                  color="primary"
                  variant="contained"
                  size="medium"
                  onClick={handleConfirmRestart}
                >
                  I'm sure, {label}
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};
